import { ShadowStyles } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { StyleSheet } from 'react-native';

import { betaBgColor } from '../AppMenu/constants';

const spacingBetweenUserInfoAndAvatar = Utils.Token.ToInt(Spacing, 'inline.xxs');
export const headerHeight = 69;
export const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: Utils.Token.ToInt(Spacing, 'inline.xxxs'),
    backgroundColor: Color['neutral.white'],
    minHeight: headerHeight,
    height: headerHeight,
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: Color['neutral.lightest'],
  },
  searchAndHamburgerContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: Utils.Token.ToInt(Spacing, 'stack.xxxs'),
  },
  searchContainerMobile: {
    flex: 1,
    paddingRight: Utils.Token.ToInt(Spacing, 'inline.xxxs'),
  },
  searchPressable: {
    padding: Utils.Token.ToInt(Spacing, 'inline.xxxs'),
  },
  searchIndicator: {
    padding: Utils.Token.ToInt(Spacing, 'inline.xxxs') - 1,
  },
  userContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacingBetweenUserInfoAndAvatar,
  },
  usernameContainer: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingRight: Utils.Token.ToInt(Spacing, 'inline.xxxs'),
  },
  userInfoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: Utils.Token.ToInt(Spacing, 'stack.nano'),
    borderRightWidth: 1,
    borderRightColor: Color['neutral.medium'],
    paddingRight: spacingBetweenUserInfoAndAvatar,
  },
  autoCompleteMenu: {
    ...ShadowStyles.Level[1],
    width: 380,
  },
  autoCompleteMenuItem: {
    width: '100%',
    borderRadius: Utils.Token.ToInt(BoxRadius, 'sm'),
    overflow: 'hidden',
    flexDirection: 'column',
    paddingHorizontal: 0,
  },
  autoCompleteMenuItemDivider: {
    marginVertical: Utils.Token.ToInt(Spacing, 'inline.nano'),
  },
  autoCompleteMenuItemAction: {
    flexDirection: 'row',
    gap: Utils.Token.ToInt(Spacing, 'stack.quarck'),
    alignItems: 'center',
    flex: 1,
  },
  autoCompleteMenuContainer: {
    flex: 1,
    maxWidth: '100%',
  },
  betaBadge: {
    backgroundColor: betaBgColor,
    borderRadius: Utils.Token.ToInt(BoxRadius, 'sm'),
    paddingHorizontal: Utils.Token.ToInt(Spacing, 'inline.nano'),
  },
});
export const menuItemBackgroundColor = {
  backgroundColor: Color['brand.tertiary.lightest'],
  ...styles.autoCompleteMenuItem,
};
export const menuItemNotFoundBackgroundColor = {
  backgroundColor: Color['neutral.white'],
  ...styles.autoCompleteMenuItem,
};
